import { select } from '@ps/web-core-store';
import { canUseDOM } from '@ps/web-core-utils';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import URL from 'url-parse';

export const usePostMessage = (
  target: Window = canUseDOM ? window.opener || window.parent : null
) => {
  const cookieDomain = useSelector(select.location.getCookieDomain);

  return useCallback(
    (message: Parameters<Window['postMessage']>[0]) => {
      const referer = new URL(document.referrer);
      if (referer.hostname.endsWith(cookieDomain)) {
        target.postMessage(message, referer.origin);
      }
    },
    [cookieDomain, target]
  );
};
